import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  router: any;
  loginresponse:any;
  userrole:any;
  userrolact:any;
  isHidden:boolean=false;
  farm_userrole:any;
  constructor() { }

  ngOnInit(): void {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
    this.userrolact=this.loginresponse.user_role;
    if(this.userrolact == 'Student/Research scholars' || this.userrolact == 'University Officer' || this.userrolact == 'Guest user' || this.userrolact == 'Farm user'  ){
    this.isHidden =true;
    var hide="exceptadmin";
    localStorage.setItem('hide',hide);
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }
   
  }

}
